/* ===========================
   Savage Industries — Theme Helpers
   =========================== */

/* ---------- 1) Sticker Grid (with dynamic header) ---------- */
(function(){
  function escapeHtml(s){return String(s||'').replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));}

  function initGrid(root){
    if(!root) return;
    const variantGrid = root.querySelector('[data-target="variant"]');
    const headerSpan  = root.querySelector('.sticker-grid__pack-name') || document.querySelector('.sticker-grid__pack-name');
    if(!variantGrid) return;

    const map     = JSON.parse(root.getAttribute('data-variant-map')||'{}');
    const initial = root.getAttribute('data-initial-variant');

    function readVariantId(){
      const form = document.querySelector('form[action*="/cart/add"]');
      if(!form) return null;
      return (
        form.querySelector('input[name="id"][type="hidden"]')?.value ||
        form.querySelector('select[name="id"]')?.value ||
        form.querySelector('input[name="id"][type="radio"]:checked')?.value || null
      );
    }

    function updateHeaderById(variantId){
      if(!headerSpan) return;
      const title = map[String(variantId)]?.title;
      headerSpan.textContent = title || 'Pack';
    }

    function render(variantId){
      const names = (map[String(variantId)]?.names)||[];
      variantGrid.innerHTML = names.length
        ? names.map(n=>`<div class="sticker-item"><span class="sticker-name">${escapeHtml(n)}</span></div>`).join('')
        : `<div class="sticker-item"><em>No stickers listed.</em></div>`;
      updateHeaderById(variantId);
    }

    // Bind form & custom events
    const form = document.querySelector('form[action*="/cart/add"]');
    const update = () => setTimeout(()=>render(readVariantId()||initial),0);

    if(form){
      form.addEventListener('change', update, true);
      form.addEventListener('input',  update, true);
      form.addEventListener('click',  update, true);
    }
    ['variant:change','variantChange','product:variant-change','theme:variant:change']
      .forEach(evt => document.addEventListener(evt, e=>{
        const id = e?.detail?.variant?.id || e?.detail?.id;
        render(id || readVariantId() || initial);
      }));

    render(readVariantId()||initial);
  }

  // Boot + Theme Editor events
  document.addEventListener('DOMContentLoaded', ()=>{
    document.querySelectorAll('.sticker-grid-wrap').forEach(initGrid);
  });
  document.addEventListener('shopify:section:load', e=>{
    e.target.querySelectorAll('.sticker-grid-wrap').forEach(initGrid);
  });
  document.addEventListener('shopify:section:select', e=>{
    e.target.querySelectorAll('.sticker-grid-wrap').forEach(initGrid);
  });
})();

/* ---------- 2) Prefer #hero media once (no obs leak) ---------- */
(function(){
  function preferHeroOnce() {
    const heroThumb = document.querySelector(
      '[data-product-thumbs] [data-product-thumb] img[alt*="#hero"],' +
      '[data-product-thumbs] [data-media-thumbnail] img[alt*="#hero"],' +
      '.product__thumb img[alt*="#hero"]'
    );
    if (!heroThumb) return;
    const clickable = heroThumb.closest('[data-product-thumb],[data-media-thumbnail],.product__thumb');
    clickable?.click();
  }

  const root = document.querySelector('[data-product-images]');
  if (!root) return;

  const thumbsReady = () =>
    root.querySelector('[data-product-thumbs]') ||
    root.querySelector('[data-media-thumbnail]') ||
    root.querySelector('.product__thumb');

  if (thumbsReady()) { preferHeroOnce(); return; }

  let obs = new MutationObserver(() => {
    if (thumbsReady()) {
      preferHeroOnce();
      obs.disconnect();
    }
  });
  obs.observe(root, { childList: true, subtree: true });
})();

/* ---------- 3) Global flags + drawer hider ---------- */
window.SI_SUPPRESS_CART_DRAWER = false;   // restore theme drawer
window.SI_ENABLE_CONFETTI      = true;    // keep confetti on add (set to false if you want it off)

// Global helper so any block can hide the drawer briefly
window.SI_temporarilyHideDrawer = function(ms=800){
  document.documentElement.classList.add('si-hide-drawer');
  setTimeout(()=> document.documentElement.classList.remove('si-hide-drawer'), ms);
};

/* ---------- 4) Add-to-cart animations only (no interception) ---------- */
(function(){
  function animatePlusOne(targetEl){
    try{
      const rect = (targetEl.getBoundingClientRect ? targetEl.getBoundingClientRect() : {left:window.innerWidth/2, top:window.innerHeight/2, width:0});
      const el = document.createElement('div');
      el.className = 'si-plusone';
      el.textContent = '+1';
      el.style.left = (rect.left + rect.width/2) + 'px';
      el.style.top  = (rect.top + window.scrollY - 6) + 'px';
      document.body.appendChild(el);
      requestAnimationFrame(()=> el.classList.add('in'));
      setTimeout(()=> el.remove(), 900);
    } catch(_){}
  }

  function confettiBurst(targetEl){
    const rect = targetEl.getBoundingClientRect();
    const originX = rect.left + rect.width / 2;
    const originY = rect.top + window.scrollY;
    const N = 18;
    for(let i=0;i<N;i++){
      const p = document.createElement('i');
      p.className = 'si-confetti';
      p.style.left = originX + 'px';
      p.style.top  = originY + 'px';
      p.style.setProperty('--dx', (Math.random()*2 - 1) * 120 + 'px');
      p.style.setProperty('--dy', (Math.random()*-1 - 0.2) * 180 + 'px');
      p.style.setProperty('--rot', (Math.random()*360) + 'deg');
      document.body.appendChild(p);
      requestAnimationFrame(()=> p.classList.add('in'));
      setTimeout(()=> p.remove(), 900);
    }
  }

  function bindFormAnimations(root){
    const forms = (root || document).querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(form=>{
      if (form.__si_anim_bound) return;
      form.__si_anim_bound = true;
      form.addEventListener('submit', (e)=>{
        // Do NOT preventDefault — let the theme handle the drawer / AJAX.
        const btn = form.querySelector('[type="submit"],button[name="add"]') || form;
        animatePlusOne(btn);
        if (window.SI_ENABLE_CONFETTI) confettiBurst(btn);
        // No custom events; let theme update counts/drawer normally.
      }, true);
    });
  }

  document.addEventListener('DOMContentLoaded', ()=> bindFormAnimations(document));
  document.addEventListener('shopify:section:load',  e=> bindFormAnimations(e.target));
  document.addEventListener('shopify:section:select',e=> bindFormAnimations(e.target));
})();
